import React from 'react';
import { LinkTW } from './LinkTW';
import { LinkProps } from 'react-router-dom';
import { IHasTestData } from '../../ui-toolkit/test-utilities/IHasTestData';

export interface IOptionalLinkTWProps extends Omit<LinkProps, 'to'>, IHasTestData {
  to?: string;
}
export const OptionalLinkTW: React.FC<IOptionalLinkTWProps> = ({
  to,
  className,
  style,
  'data-test-id': dataTestId,
  ...rest
}) => {
  return (
    <>
      {to && <LinkTW {...rest} to={to} className={className} style={style} data-test-id={dataTestId} />}
      {!to && (
        <div className={className} style={style} data-test-id={dataTestId}>
          {rest.children}
        </div>
      )}
    </>
  );
};
